<select [(ngModel)]="selectedYear" class="form-control" (change)="onChangeSelectedValue($event)" data-element-id="app-content-components-container-air-year-pulldown">
    <option *ngFor="let year of yearList" [value]="year">{{year}}</option>
</select>
